import { render, staticRenderFns } from "./DsArrowDown.vue?vue&type=template&id=159f7066&scoped=true"
import script from "./DsArrowDown.vue?vue&type=script&lang=js"
export * from "./DsArrowDown.vue?vue&type=script&lang=js"
import style0 from "./DsArrowDown.vue?vue&type=style&index=0&id=159f7066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f7066",
  null
  
)

export default component.exports